<template lang="html">
  <div class="content myClue">
    <div :class="{list: true,empty: list && list.length === 0}">
      <div class="headline">
        <div class="nav">
          <li v-for="(f, i) in filters" :key="i">
            <div class="status">
              <label>{{f.title}}</label>
              <span :class="{active: s.selected}" v-for="(s, si) in f.list" @click="choseStatus(s, f)">{{s.title}}</span>
            </div>
          </li>
        </div>
        <div class="new" @click="goClue()" v-show="showCreate">
          <img src="@assets/img/common/upload.svg" alt="upload">
          <span>{{`上传${$_syscfg.clue}`}}</span>
        </div>
      </div>
      <empty v-if="list && list.length === 0" :msg="`暂无${$_syscfg.clue}数据`" />
      <skeleton v-show="waiting"></skeleton>
      <div v-show="!waiting" :class="{items: true, warn: report.has_warning}" v-for="(report, i) in list" :key="i">
        <img v-if="report.has_warning" src="@assets/img/common/warnTag.svg" alt="warn" class="warning">
        <div class="item">
          <div :style="'background: url('+ report.cover +') no-repeat;background-size: 100% 100%;background-position: center center;'" class="pic" @click="viewMedia(report)">
            <div v-show="isChrome" class="backDrop"></div>
            <div v-show="!isChrome" :style="'background: url('+ report.cover +') no-repeat;'" class="blur"></div>
            <img @error="imgError(report)" class="main" :src="report.cover || '@assets/img/common/default.png'" alt="pic">
            <!-- <img class="main" src="@assets/img/common/default.png" alt="default" v-if="!report.cover"> -->
            <img v-if="report.play_icon - 0 === 1 && report.cover" class="play" src="@assets/img/index/play.svg" alt="play" >
          </div>
          <div class="article">
            <div class="title" @click="handleGo(report)">
              <p class="tag" v-if="report.status == '0'">{{report.status_name}}</p>
              <p class="words" :title="report.title">
                {{report.title}}
              </p>
              <img src="@assets/img/common/tips.svg" alt="change" v-if="report.has_change - 0 === 1">
              <img src="@assets/img/common/new.svg" alt="new" v-if="report.is_new - 0 === 1">
              <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="report.has_img - 0 === 1">
              <img src="@assets/img/common/videoIcon.svg" alt="video" v-if="report.has_video - 0 === 1">
              <img src="@assets/img/common/audioIcon.svg" alt="audio" v-if="report.has_sound - 0 === 1">
            <img alt="技审未通过" title="技审未通过" class="verify-logo" v-if="report.has_audit&&report.has_audit==2" src="@assets/img/common/verify-fail.svg">
            </div>
            <p class="content">
              {{report.content}}
            </p>
            <div class="footline">
              <p class="mark">
                <img src="@assets/img/common/xy.svg" alt="user">
                <span>{{report.source_info.ptitle}}</span>
              </p>
              <p class="mark">
                <img src="@assets/img/common/zz.svg" alt="time">
                <span>{{report.username}}</span>
              </p>
              <p class="mark">
                <img src="@assets/img/index/time.svg" alt="time">
                <span>{{report.release_time}}</span>
              </p>
              <p class="mark caiyong">
                <img src="@assets/img/index/beUse.svg" alt="tv">
                <span>
                  {{`被采用 ${report.use_num}`}}
                  <span class="tips" v-if="report.use_num - 0 !== 0">
                    <span v-for="(r, ri) in report.reports" class="tip" @click="goRptDtl(r)">
                      <span class="tiptitle">{{r.title}}</span>
                      <span class="tiper">{{r.user_name}}</span>
                      <span class="tiptime">{{r.raw_add_time}}</span>
                    </span>
                  </span>
                </span>
              </p>
            </div>
          </div>
          <div class="handles" :class="{twoline:report.status == '1' && report.has_report_role && enablePush&&report.has_publish}">
            <div class="handle greenBtn s" v-if="report.status == '0'" @click="upload(report)">
              上传
            </div>
            <div class="handle s" v-if="report.status == '0'" @click="goEdit(report.id)">
              编辑
            </div>
            <div class="handle s" v-if="report.status == '0'" @click="deleteItem(report)">
              删除
            </div>
            <div v-if="report.status != 0" class="pushBtn">
              <p :class="{on: report.showPushBtns}">
                <span>推送</span>
                <i></i>
              </p>
              <div class="btn">
                <span></span>
                <ul>
                  <li v-if="report.has_report_role && enablePush" @click="goReport(report,i)">{{`推送${$_syscfg.report}`}}</li>
                  <li v-if="report.has_publish" @click="pushPublish(report.id, 'material', i)">{{`推送${$_syscfg.publish}`}}</li>
                  <li v-if="report.has_new_media" @click="pushMedia(report, i)">{{`推新发布`}}</li>
                </ul>
              </div>
            </div>
            <div v-if="report.status != 0" class="threePoint">
              <i></i>
              <div class="btn">
                <span></span>
                <ul>
                  <li v-if="report.status == '0'" @click="upload(report)">{{`上传`}}</li>
                  <li v-if="report.status == '1'" @click="goEdit(report.id)">{{`更新`}}</li>
                  <li v-if="report.status == '0'" @click="goEdit(report.id)">{{`编辑`}}</li>
                  <li @click="mediaSend(report.id, i)" v-if="report.has_stream_send">{{`归档`}}</li>
                  <li v-if="report.status == '0' || report.status == '1'" @click="deleteItem(report)">{{`删除`}}</li>
                </ul>
              </div>
            </div>
            <!-- <div class="handle push l" v-if="report.status == '1' && report.has_report_role && enablePush" @click="goReport(report)">
              {{`推送${$_syscfg.report}`}}
            </div>
            <div class="handle push l" v-if="report.has_publish" @click="pushPublish(report.id, 'material')">
              {{`推送${$_syscfg.publish}`}}
            </div>
            <div class="handle push l" v-if="report.has_new_media" @click="pushMedia(report)">
              推新发布
            </div>
            <div class="handle greenBtn s" v-if="report.status == '0'" @click="upload(report)">
              上传
            </div>
            <div class="handle s" v-if="report.status == '1'" @click="goEdit(report.id)">
              更新
            </div>
            <div class="handle s" v-if="report.status == '0'" @click="goEdit(report.id)">
              编辑
            </div>
            <div class="handle s" v-if="report.status == '0' || report.status == '1'" @click="deleteItem(report)">
              删除
            </div> -->
          </div>
        </div>
      </div>
      <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total" />
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import pages from "@components/pages";
import empty from "@components/empty";
import skeleton from "@components/skeleton";

export default {
  components: { pages, empty, skeleton },
  data() {
    return {
      waiting: true,
      isXnew: this.$store.state.isXnew,
      list: null,
      filters: [],
      filterOptions: {},
      searchOptions: {},
      page: {
        pageIndex: 1,
        pageCount: 0,
        pageSize: 10,
        total: 0
      },
      showCreate: false,
      defaultImg: require("@assets/img/common/default.png"),
      enablePush: false,
      isChrome: true
    };
  },
  methods: {
    mediaSend(id, index) {
      this.list[index].showThreePoint = false;
      let info = {
          subject_type: 0,
          subject_id: id
      };
      common
      .myFetch(apis.streamMediaSend, info)
      .then(r => {
          if (r) {
              this.$toast(r)
          }
      });
    },
    setShowPushBtns(index) {
      this.list.forEach((el,key) => {
        if(key != index){
          el.showPushBtns = false;
        }
        el.showThreePoint = false;
      });
      this.list[index].showPushBtns = !this.list[index].showPushBtns      
    },
    setShowThreePoint(index) {
      this.list.forEach((el,key) => {
        if(key != index){
          el.showThreePoint = false;
        }
        el.showPushBtns = false;
      });
      this.list[index].showThreePoint = !this.list[index].showThreePoint      
    },
    async pushMedia(item, index) {
      console.log(item)
      const type = await this.$MediaPlatform('push');
      if (!type) return;
      console.log(type)
      this.list[index].showPushBtns = false;
      let info = {
          platforms: type,
          submit_type: 0,
          subject_type: 0,
          subject_id: item.id
      };

      common
      .myFetch(apis.newMediaPlatformCreate, info)
      .then(r => {
          if (r) {
              console.log(r)
              common.jump(`/createMediaPublish?d=${r.report_id}`, true);
          }
      });
      // common.jump(`/createMediaPublish?d=${type}`, true);
    },
    async pushPublish(id, t, index) {
      // 推送发布
      const type = await this.$pageType("publish");
      if (!type) return;
      this.list[index].showPushBtns = false;
      const info = {
        subject_id: id,
        subject_type: t,
        type: type
      };

      common.myFetch(apis.publish_pushPublish, info).then(r => {
        if (r) {
          const url = `/editPublish?t=${type}&d=${r.id}`;

          common.jump(url, true);
        }
      });
    },
    imgError(i) {
      // 图片加载状态
      this.$set(i, "cover", this.defaultImg);
    },
    viewMedia(data) {
      // 浏览稿件媒体
      // common.viewMedia(data, null, false)
      console.log('data', data)
      common.openMaterialBox(data, null, false);
    },
    goClue() {
      common.jump("/creatClue?t=0", true);
    },
    async goReport(i, index) {
      const type = await this.$pageType();
      if (!type) return;
      this.list[index].showPushBtns = false;
      const info = {
        id: i.id,
        type: type
      };
      const newWindow = window.open();

      common.myFetch(apis.clue_toReport, info).then(r => {
        if (r) {
          const reportId = r.report_id;

          newWindow.location.href = `${window.location.origin
            }/creatReport?push=${i.id}&t=${type}&d=${reportId}`;

          // common.jump(`/creatReport?push=${i.id}&t=${type}&d=${reportId}`, true)
        }
      });
    },
    goRptDtl(r) {
      if (!r.has_report_detail_role) {
        this.$toast("无访问权限");
        return;
      }

      common.jump(`/reportDetail?d=${r.report_id}`, true);
    },
    upload(c) {
      this.list.forEach(el => {
        el.showPushBtns = false;
        el.showThreePoint = false;
      })
      const info = {
        id: c.id
      };

      common.myFetch(apis.uploadClue, info).then(r => {
        if (r) {
          this.$toast(r);

          this.getList();
        }
      });
    },
    async deleteItem(c) {
      // const confirm = await this.$confirmTitle({
      //   title: `确定删除该${this.$_syscfg.clue}？`,
      //   msg: "同时删除关联素材，释放草稿空间",
      //   status: true
      // });
      // const confirm = await this.$confirm(`删除该${this.$_syscfg.clue}？`);
      this.list.forEach(el => {
        el.showPushBtns = false;
        el.showThreePoint = false;
      })

      let confirm = {};

      if(c.status == 0){
        confirm = await this.$confirmTitle({
          title: `确定删除该${this.$_syscfg.clue}？`,
          msg: "同时删除关联素材，释放草稿空间",
          status: true,
          isCg: c.status == 0 ? true : false
        });
      }else{
        let msg = `删除该${this.$_syscfg.clue}？`;

        confirm.status = await this.$confirm(msg);
        confirm.isSelected = 0;
      }
      
      if (!confirm.status) return;

      const info = {
        material_id: c.id,
        del_source: confirm.isSelected ? 1 : 0
      };

      common.myFetch(apis.deleteClue, info).then(r => {
        if (r) {
          this.$toast(r);

          this.getList();
        }
      });
    },
    getFilters(data) {
      // 获取过滤条件数据
      // this.filterOptions = data
      this.filterOptions = Object.assign({}, this.filterOptions, data);

      this.getList();
    },
    getList(keyWord) {
      // 获取列表数据
      this.waiting = true;
      const id = this.$route.params.id;
      const info = {
        idstring: id,
        pagesize: this.page.pageSize,
        page: this.page.pageIndex,
        search_option: "",
        key_words: "",
        status: ""
      };

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions);

      common.myFetch(apis.myClue, info).then(res => {
        if (res) {
          res.list.forEach(el => {
            el.showPushBtns = false;
            el.showThreePoint = false;
          });
          this.list = res.list;
          this.enablePush = !!res.reportExist;
          this.filters = [res.params.list_search];
          this.generateSearchs(res.params.top_search.option.list);
          this.$set(
            this.page,
            "pageCount",
            common.calculatePage(res.page.row_count - 0, this.page.pageSize)
          );
          this.$set(this.page, "total", res.page.row_count - 0);
          this.showCreate = res.has_add_role;

          this.$nextTick(() => {
            this.waiting = false;
          })
        }
      });
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.postSearch(filterData);
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit("filterData", data);
    },
    choseStatus(i, l) {
      // 选择筛选项
      if (i.selected) return;

      this.page.pageIndex = 1;

      l.list.forEach(li => {
        li["selected"] = false;
      });

      this.$set(i, "selected", true);
      this.filterOptions[l.key] = i.key;
      this.getList();
    },
    handleGo(i) {
      const s = i.status;
      this.$set(i, "has_change", 0);
      this.$set(i, "is_new", 0);

      if (s == 0) {
        this.goEdit(i.id);
      } else {
        this.goDetail(i.id);
      }
    },
    goDetail(id) {
      common.jump(`/clueDetail?d=${id}`, true);
      // this.$router.push({
      //   path: 'clueDetail',
      //   query: {
      //     d: id
      //   }
      // })
    },
    goEdit(id) {
      // 编辑或更新
      this.list.forEach(el => {
        el.showPushBtns = false;
        el.showThreePoint = false;
      })
      common.jump(`/editClue?d=${id}`, true);
    }
  },
  beforeDestroy() {
    this.$AiMessage(true)
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    const params = this.$route.params;
    Object.assign(this.filterOptions, params);

    this.getList('noKeyWord');
    var agent = navigator.userAgent.toLowerCase();
    if(agent.indexOf("chrome") > 0) {
      this.isChrome = true
    }else{
      this.isChrome = false
    }
    this.$AiMessage()
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.blur {
  width: 100%;
  height: 100%;
  filter: blur(5px);
  background-position: center center !important;
  background-size: 100% 100% !important;
}

.backDrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
}
.content.myClue {
  display: flex;
  flex-direction: column;
}

.list {
  &.empty {
    display: flex;
    flex-direction: column;
    flex: 1;

    &>.empty {
      flex: 1
    }
  }
  .boxOuter;
  // margin-top: 30px;
  padding-bottom: 50px;
  .headline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    padding: 0 30px;
    border-bottom: 1px solid #f0f0f0;
    box-sizing: border-box;
    .nav {
      width: 100%;
      height: 70px;
      line-height: 70px;
      display: flex;
      // padding: 0px 30px;
      // border-bottom: 1px solid #f0f0f0;
      li {
        flex: 1;
        font-size: 18px;
        color: @dateColor;
        cursor: pointer;
        display: flex;
        align-items: center;
        span {
          line-height: 25px;
          margin-right: 40px;
          padding-bottom: 5px;
          border-bottom: 2px solid @bg;
          &.active {
            color: @green;
            border-bottom: 2px solid @green;
          }
        }
        .status {
          height: 30px;
          line-height: 30px;
          color: @sub;
          display: flex;
          label {
            display: block;
            width: 52px;
            font-size: 13px;
            text-align: justify;
            margin-right: 30px;
            color: @green;
            font-weight: bold;
            &::after {
              content: "";
              display: inline-block;
              padding-left: 100%;
            }
          }
          span {
            display: block;
            min-width: 78px;
            line-height: 30px;
            font-size: 14px;
            padding: 0px;
            margin-right: 3px;
            text-align: center;
            border-radius: 100px;
            &.active {
              color: @green;
              border: 1px solid @green;
            }
          }
        }
      }
    }
    .new {
      // padding: 10px 20px;
      justify-content: center;
      width: 120px;
      height: 40px;
      font-size: 14px;
      background-color: @green;
      color: #fff;
      border-radius: 100px;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      font-weight: bold;
      cursor: pointer;
      img {
        margin-right: 10px;
      }
      &:active {
        .btnActive;
      }
      &:hover {
        .btnHover;
      }
    }
  }
  .items:last-child {
    .item {
      border: none;
    }
  }
  .items {
    padding: 0 30px;
    position: relative;
    .warning {
      position: absolute;
      left: 0;
      top: 0;
    }
    &.warn {
      background: rgba(240, 193, 41, 0.15);
    }
    &:hover {
      .item {
        .handles {
          visibility: visible;
        }
      }
      background-color: rgba(185, 195, 195, 0.15);
    }
    .item {
      padding: 20px 0;
      height: 190px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      align-items: center;
      .pic {
        flex-shrink: 0;
        width: 240px;
        height: 135px;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        .tags {
          position: absolute;
          padding: 4px 10px;
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: 4px 0 16px 0;
          img {
            margin-left: 8px;
          }
          img:first-child {
            margin-left: 0;
          }
        }
        .main {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: contain;
          background: transparent;
        }
        .play {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          // box-shadow:4px 4px 10px 0 rgba(5,10,15,0.05);
        }
      }
      .article {
        flex: 1;
        margin: 0 40px 0 30px;
        height: 135px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          // width: 0;
          overflow: hidden;
          cursor: pointer;
          display: flex;
          align-items: center;
          .verify-logo {
            width: 22px;
          }
          &:hover {
            .words {
              color: @green;
            }
          }
          .tag {
            height: 20px;
            border-radius: 100px;
            border: 1px solid @green;
            color: @green;
            min-width: 50px;
            text-align: center;
            line-height: 20px;
            font-size: 13px;
            margin-right: 8px;
          }
          .words {
            color: @dark;
            font-size: 18px;
            font-weight: bold;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          img {
            margin-left: 8px;
          }
        }
        .content {
          color: @sub;
          font-size: 14px;
          line-height: 24px;
          text-align: justify;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .footline {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .caiyong {
            cursor: pointer;
          }
          .mark {
            display: flex;
            align-items: center;
            // flex: 1;
            overflow: hidden;
            // position: relative;
            margin-left: 40px;
            .tips {
              position: absolute;
              display: none;
              margin: 0 0 0 -142px;
              border-radius: 4px;
              overflow: hidden;
              background-color: rgba(5, 15, 15, 0.8);
              width: 340px;
              height: auto;
              padding: 5px 20px;
              box-sizing: border-box;
              z-index: 5;
              .tip {
                cursor: pointer;
                height: 20px;
                margin: 5px 0;
                display: flex;
                align-items: center;
                font-size: 14px;
                color: @dateColor;
                .tiptitle {
                  color: #fff;
                  flex: 1;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .tiper {
                  width: 42px;
                  flex-shrink: 0;
                  margin-right: 10px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .tiptime {
                  flex-shrink: 0;
                  // width: 72px;
                }
                &:hover {
                  text-decoration: underline;
                }
              }
              &:hover {
                display: block;
              }
            }
            span {
              color: @dateColor;
              font-size: 14px;
              margin-left: 8px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &:hover {
              .tips {
                display: block;
              }
            }
          }
          .mark:first-child {
            margin: 0;
          }
        }
      }
      .greenBtn {
        background-color: @green !important;
        color: #fff !important;
      }
      .ml {
        margin-left: 140px;
      }
      .handles {
        flex-shrink: 0;
        // max-width: 150px;
        flex-wrap: wrap;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        // visibility: hidden;
        &.twoline {
          max-width: 150px;
        }
        .s {
          width: 40px;
        }
        .m {
          width: 60px;
        }
        .l {
          width: 70px;
        }
        .pushBtn {
          position: relative;
          margin-right: 10px;

          &:hover {
            .btn {
              display: flex;
            }

            i {
              transform: rotate(180deg);
            }
          }

          .btn {
            display: none;
            flex-direction: column;
            position: absolute;
            top: 30px;
            right: 0;
            z-index: 9;

            span {
              display: block;
              width: 78px;
              height: 6px;
            }
          }

          ul {
            width: 78px;
            background-color: rgba(5,15,15,0.8);
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            overflow: hidden;

            li {
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 13px;
              font-weight: bold;
              color: #FFFFFF;
              user-select: none;
              cursor: pointer;

              &:hover {
                background: rgba(255, 255, 255, 0.1);
              }
            }
          }

          &>p {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 30px;
            padding: 0 6px 0 7px;
            line-height: 30px;
            background-color: @green;
            color: #fff;
            border-radius: 4px;
            font-size: 14px;
            box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
            cursor: pointer;
            font-weight: bold;
            box-sizing: border-box;

            &.on {
              i {
                transform: rotate(180deg);
              }
            }

            i {
              display: block;
              width: 13px;
              height: 7px;
              background: url('../../assets/img/common/upArrow.png') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
              margin-left: 6px;
              user-select: none;
              cursor: pointer;
            }
          }
        }
        .threePoint {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 30px;
          height: 30px;
          background: #FFF;
          border-radius: 4px;
          box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
          cursor: pointer;

          &:hover {
            .btn {
              display: flex;
            }
          }

          .btn {
            position: absolute;
            top: 30px;
            right: 0;
            z-index: 9;
            display: none;
            flex-direction: column;

            span {
              width: 78px;
              height: 6px;
            }
          }

          ul {
            width: 78px;
            z-index: 9;
            background-color: rgba(5,15,15,0.8);
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            overflow: hidden;

            li {
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 13px;
              font-weight: bold;
              color: #FFFFFF;
              user-select: none;
              cursor: pointer;

              &:hover {
                background: rgba(255, 255, 255, 0.1);
              }
            }
          }

          i {
            display: block;
            width: 30px;
            height: 30px;
            background: url('../../assets/img/common/threeBtn.png') no-repeat;
            background-position: center center;
            background-size: 16px 4px;
          }
        }
        .handle {
          margin-bottom: 10px;
          word-break: keep-all;
          background-color: #fff;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: @sub;
          font-size: 14px;
          box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
          cursor: pointer;
          margin-left: 10px;
          &:active {
            .btnActive;
          }
          &:hover {
            .btnHover;
          }
          &.push:first-child {
            .greenBtn;
          }
        }
        .handle:first-child {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
